import axios from 'axios';
import { ENV_CONFIG } from '../../../config/config';

export const reportantesApi = (tokenAutorizacion:any) => axios.create({
    baseURL: `${ENV_CONFIG.REPORTANTES_URL}`,
    headers: {
        'Authorization': 'Bearer ' + tokenAutorizacion,
        'Content-Type': 'application/json'
    }
});